/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Button, Dropdown } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory } from 'react-router-dom';
import _, { groupBy } from 'lodash';
import { object } from 'prop-types';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tableHead } from './tableHead';
import {
  getCreditDebit,
  getTopBalances,
  getExportAllData,
  getExportBalData,
  setPaginationIndex,
  setSelectedClaim,
} from './Store/action';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import PaginationBox from './PaginationBox';
import { viewPortHeight_355 } from '../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import { exportAllPDF, exportAllPDFTopBalance } from '../../../SharedModules/pdfExport/exportAll';
import {
  FAIL_PROCESSING_REQUEST,
  NO_DATA,
} from '../../../SharedModules/Errors/constantMessageData';
import { getInvoiceHeader } from '../../Tasks/AllocatePayments/PQASTab/store/Actions';
import {
  dispatchNDCBalanceDue,
  dispatchNDCOveridden,
  dispatchNDCPaidInFull,
  ndcDetailFirstLoadAction,
  ndcDetailSingle,
} from '../../Research/AccountReceivable/AccRecNDCDetail/store/actions';
import { getAccRecNDCSingleDetail } from '../../Research/AccountReceivable/QtrAccountsRec/store/actions';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import './style.scss';
import { goToArSummaryAccRecNDCSingle } from '../../Research/AccountReceivable/ARCommonFunctions';
import { convertCurrencyStringToNumber } from '../../../SharedModules/CommonUtilities/commonUtilities';

const DisplayTopBalances = () => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      from: getQuarterFrom,
      quarterRange: getQuarterRange,
      to: getQuarterTo,
      creditDebit: getCreditDebitListData,
      selectedDisplayValue: getManufacturerListData,
      balanceDue: getBalanceDueListData,
      credit: getCreditDebitIndexListData,
      dramsData,
      firstSummaryData,
      countValue,
    },
    exportAllData,
  } = useSelector((state) => state?.sharedState?.TopBalancesReducer);
  const balanceDue = useSelector(
    (state) => state?.sharedState?.TopBalancesReducer?.balanceDue
  );
  const detailBalanceDue = useSelector(
    (state) => state?.sharedState?.TopBalancesReducer?.detailBalanceDue
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const getSingleAccRecNDCList = useSelector(
    (state) =>
      state?.sharedState?.QtrAccountsRecReducer?.getSingleAccRecNDCList
        ?.acctRecvMfgNDCDetaillSingleServiceResonse
        ?.acctRecvMfgNDCDetailSingleRpcResponseVO[0].status
  );

  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [columnApi, setColumnApi] = React.useState(null);
  // const [unallocated, setUnallocated] = React.useState(0);
  // const [totalValue, setTotalValue] = React.useState(0);
  const [topBalances, setTopBalances] = React.useState([]);
  const [balData, setBalData] = React.useState([]);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [isExportAllClick, setIsExportAllClick] = React.useState(false);
  const [count, setCount] = React.useState(countValue);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const paginationLength =
    getManufacturerListData > balData?.length
      ? balData.length
      : getManufacturerListData;

  const p = [];
  for (let i = 0; i < paginationLength; i += 1) {
    p.push(i);
  }
  const paginationArray = p;
  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    const pageNumber = parseInt(value);
    let currentPage = 1;
    if (value === '' || isNaN(pageNumber) || pageNumber < 1) {
      currentPage = 1;
      setCount(1); 
    } else if (pageNumber > paginationArray.length) {
      currentPage = paginationArray.length;
      setCount(paginationArray.length);
    } else {
      setCount(pageNumber);
      currentPage = pageNumber;
    }
    return currentPage;
  };

  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3) + 1;
  const year = today.getFullYear();
  const quarterString = quarter.toString();
  const yearString = year.toString();
  const formattedQuarter = quarterString.padStart(2);

  const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;

  const dateRange = {
    'DRAMS Invoice Start Quarter': {
      beginDate: dramsData,
      endDate: currentQuarterWithYear,
    },
    All: {
      beginDate: '1Q1991',
      endDate: currentQuarterWithYear,
    },
    'First Summary Report Quarter': {
      beginDate: firstSummaryData,
      endDate: currentQuarterWithYear,
    },

    'Selected Range': {
      beginDate: getQuarterFrom,
      endDate: getQuarterTo != '' ? getQuarterTo : currentQuarterWithYear,
    },
  };

  // React.useEffect(() => {
  //   if (getRebateProgramName?.rebateProgramCd && count) {
  //     dispatch(
  //       getTopBalances({
  //         rebateProgramCd: getRebateProgramName?.rebateProgramCd,
  //         startQtr: dateRange[getQuarterRange]?.beginDate || '',
  //         endQtr: dateRange[getQuarterRange]?.endDate || '',
  //         creditDebitIndex: getCreditDebitIndexListData,
  //       })
  //     );
  //   }
  // }, [count, getRebateProgramName]);
  React.useEffect(() => {
    // const data = balanceDue?.rebateTopBalancesReportVO || [];
    setBalData(detailBalanceDue);
  }, [detailBalanceDue]);

  const sortedData2 = balData;
  const mfgValue = sortedData2[count - 1]?.mfgId;

  // const totalBalance = Number(balData[count - 1]?.balanceDue);
  let totalBalance = 0;

  // commenting out below code because no need to sum all unallocated_BALANCE but take only one value.
  // for (let i = 0; i < topBalances?.length; i++) {
  //   totalBalance += topBalances[i].unallocated_BALANCE;
  // }

  if (topBalances?.length > 0) {
    totalBalance = topBalances[0].unallocated_BALANCE;
  }

  let balance_due;
  if (totalBalance == null) balance_due = '0.00';
  else balance_due = totalBalance;
  const formattedBalance = balance_due.toLocaleString(); // Add commas
  const balance_due1 =
    // <span className={balance_due < 0 ? 'negative-balance' : 'positive-balance'}>
    balance_due !== undefined && !isNaN(balance_due)
      ? balance_due < 0
        ? `${'(' + '$ '}${parseFloat(-balance_due).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })})`
        : `$ ${parseFloat(balance_due).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
      : '';
  // </span>
  const balance_due1Text = balance_due1;

  // dispatch
  React.useEffect(() => {
    if (mfgValue) {
      dispatch(
        getCreditDebit({
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
          mfgId: [mfgValue],
          startQtr: dateRange[getQuarterRange].beginDate,
          endQtr: dateRange[getQuarterRange].endDate,
        })
      );
    }
  }, [count]);

  React.useEffect(() => {
    const data1 = getCreditDebitListData?.rebateTopBalancesGridReportVO;
    const newData = data1?.map((item) => {
      const principal_BAL = item.principal_BAL
        ? item.principal_BAL.toFixed(2)
        : '0.00';
      const interest_DUE = item.interest_DUE
        ? item.interest_DUE.toFixed(2)
        : '0.00';
      const top_balances_balance_due = (
        Number(item.principal_BAL) + Number(item.interest_DUE)
      ).toFixed(2);

      return {
        ...item,
        principal_BAL,
        interest_DUE,
        top_balances_balance_due,
      };
    });
    const sortedData = sortData(newData);
    setTopBalances(sortedData);

    // const unallocated = sortedData?.reduce(
    //   (acc, obj) => acc + obj.unallocated_BALANCE,
    //   0
    // );
    // const balanceDue = sortedData?.reduce(
    //   (acc, obj) => acc + obj.top_balances_balance_due,
    //   0
    // );
    // if (unallocated) setUnallocated(unallocated);
    // else setUnallocated(0);
    // if (unallocated && balanceDue) setTotalValue(unallocated + balanceDue);
    // else setTotalValue(0);
  }, [getCreditDebitListData]);

  function sortData(data) {
    return data?.sort((a, b) => {
      const [aQtr, aYear] = a.qtr.split('Q');
      const [bQtr, bYear] = b.qtr.split('Q');
      if (aYear !== bYear) {
        return bYear - aYear;
      }
      return bQtr - aQtr;
    });
  }
  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setIsExportAllClick(true);
    if (mfgValue) {
      dispatch(
        getExportAllData(
          {
            rebateProgramCd: getRebateProgramName?.rebateProgramCd,
            mfgId: sortedData2,
            startQtr: dateRange[getQuarterRange].beginDate,
            endQtr: dateRange[getQuarterRange].endDate,
          },
          getManufacturerListData
        )
      );
    }
  };

  const addPinnedRowData = (exportAllData) => {
    const exportAllDataObj = {};

    for (const key in exportAllData) {
      const data = exportAllData[key];

      const pinnedRow = {
        qtr: 'Total',
        principal_BAL: 0,
        interest_DUE: 0,
        top_balances_balance_due: 0,
        bold: true,
      };

      let unallocatedBalance = 0;
      let totalBalanceDue = 0;

      for (let i = 0; i < data.length; i += 1) {
        pinnedRow.principal_BAL += data[i].principal_BAL;
        pinnedRow.interest_DUE += data[i].interest_DUE;
        pinnedRow.top_balances_balance_due += data[i].top_balances_balance_due;

        unallocatedBalance += data[i].unallocated_BALANCE;
        totalBalanceDue =
          pinnedRow.top_balances_balance_due + data[i].top_balances_balance_due;
      }

      data.push(pinnedRow);

      // Add Unallocated Balance row
      const unallocatedBalanceRow = {
        qtr: 'Unallocated Balance',
        principal_BAL: null,
        interest_DUE: null,
        top_balances_balance_due: unallocatedBalance,
        hideInGrid: true,
        isBottomRowSup: true,
      };
      data.push(unallocatedBalanceRow);

      // Add Total Balance Due row
      const totalBalanceDueRow = {
        qtr: 'Total Balance Due',
        principal_BAL: '',
        interest_DUE: '',
        top_balances_balance_due: totalBalanceDue,
        hideInGrid: true,
        isBottomRowSup: true,
      };
      data.push(totalBalanceDueRow);

      // Store modified data
      exportAllDataObj[key] = data;
    }

    return exportAllDataObj;
  };

  // const createData = (count, prefix) => {
  //   const result = [];
  //   for (let i = 0; i < count; i += 1) {
  //     // Define the content of each row based on the iteration
  //     const row = {
  //       isBottomRow: true,
  //       action: '',
  //       qtr: i === 0 ? 'Total' : 'Summary', // First row as 'Total', second as 'Summary'
  //       invoice_NUM: '',
  //       principal_BAL: sum('principal_BAL'),
  //       interest_DUE: sum('interest_DUE'),
  //       top_balances_balance_due: sum('top_balances_balance_due'),
  //     };
  //     result.push(row);
  //   }
  //   return result;
  // };
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  React.useEffect(() => {
    if (isExportAllClick) {
      setIsExportAllClick(false);
      const header = {
        reportName: `Top ${getManufacturerListData} ${
          getCreditDebitIndexListData === '0' ? 'Credit' : 'Debit'
        } Balances Due Report`,
        fileName: exportFileName,
      };
      const allData = exportAllData?.map((item) => {
        const top_balances_balance_due =
          Number(item.principal_BAL) + Number(item.interest_DUE);
        return {
          ...item,
          top_balances_balance_due,
        };
      });

      const groupedData = groupBy(allData, 'mfg_ID');
      for (const key in groupedData) {
        groupedData[key].sort((a, b) => {
          const splittedQtrA = a.qtr?.split('Q');
          const splittedQtrB = b.qtr?.split('Q');
          return (
            -1 *
            (splittedQtrA[1] - splittedQtrB[1] ||
              splittedQtrA[0] - splittedQtrB[0])
          );
        });
      }
      const mapping = {};
      const map = {};
      exportAllData.forEach((item) => {
        if (item.mfg_ID && item.mfg_NAME && !mapping[item.mfg_ID]) {
          mapping[item.mfg_ID] = item.mfg_NAME;
          map[item.mfg_ID] = item.mfg_ID;
        }
      }); 
      const paginationArr = sortedData2.map((item) => item.mfgId);
      const options = {
        info: {
          // firstInfo: `Manufacturer ID `,
          secondInfo: `Report Quarter Option: ${
            getQuarterRange == 'Selected Range'
              ? `${getQuarterFrom}-${getQuarterTo}`
              : getQuarterRange
          }`,
          thirdInfo: `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`,
          fourthInfo: '',
          sixthInfo: ' ',
        },
        titleName: 'Manufacturer Name: ',
        mapping,
        // New object for additional title
        title: 'Manufacturer Id: ',
        map,
      };
      const widths = [];

      const allRowData = addPinnedRowData(groupedData);

      const filteredTableHead = tableHead.filter(
        (item) => item.headerName != 'Actions'
      );
      exportAllPDFTopBalance(
        header,
        allRowData,
        columnApi,
        userDefaults,
        options,
        paginationArr,
        widths,
        logInUser
      );
    }
  }, [exportAllData]);
  const [errorMessage, setErrorMessage] = React.useState('');

  // handing Go to NDCDetails redirection
  const handleGotoNDCDetails = async (selectedClaim) => {
    setErrorMessage('');
    const isPaidQtr = selectedClaim?.qtr;

    const payload_inv = {
      isPrevQTR: isPaidQtr,
      isProgramCode: getRebateProgramName?.rebateProgramCd,
      isMFG: selectedClaim?.mfg_ID,
    };
    try {
      const result = await dispatch(getInvoiceHeader(payload_inv));
      let invoiceNumber;
      let invoiceDate;
      if (
        result &&
        result?.payload &&
        result?.payload?.postInitByInvoiceHeaderResp.length > 0
      ) {
        invoiceNumber =
          result?.payload?.postInitByInvoiceHeaderResp[0]?.idecPrevInvoiceNum;
        invoiceDate =
          result?.payload?.postInitByInvoiceHeaderResp[0]?.idtPrevInvDate;

        const payload = {
          mfgId: selectedClaim?.mfg_ID,
          startQuarter: isPaidQtr,
          aiUseOfficialURA: '1',
          invoiceNumber: invoiceNumber,
          rebateProgramCd: getRebateProgramName?.rebateProgramCd,
        };
        const obj = {
          mfgId: selectedClaim?.mfg_ID,
          mfgName: selectedClaim?.mfg_NAME,
          getQuarterValue: isPaidQtr,
          pgmInfo: getRebateProgramName?.rebateProgramCd,
          uraInfo: 'Official',
          invoiceStatus: getSingleAccRecNDCList,
          invoiceStatusCd: getSingleAccRecNDCList,
          invoiceNum: invoiceNumber,
          invoiceDate: invoiceDate,
          pgmCd: getRebateProgramName?.rebateProgramCd,
        };
        const accountRecResponse = await dispatch(
          getAccRecNDCSingleDetail(payload)
        );
        await dispatch(ndcDetailSingle(obj));
        const {
          dispBalanceDueNdcInd,
          dispOverriddenNdcInd,
          dispPaidInFullNdcInd,
        } = userDefaults || {};
        dispatch(
          dispatchNDCPaidInFull(
            dispPaidInFullNdcInd
              ? {
                  [getRebateProgramName?.rebateProgramCd]: true,
                }
              : {
                  [getRebateProgramName?.rebateProgramCd]: false,
                }
          )
        );
        dispatch(
          dispatchNDCOveridden(
            dispOverriddenNdcInd
              ? {
                  [getRebateProgramName?.rebateProgramCd]: true,
                }
              : {
                  [getRebateProgramName?.rebateProgramCd]: false,
                }
          )
        );
        dispatch(
          dispatchNDCBalanceDue(
            dispBalanceDueNdcInd
              ? {
                  [getRebateProgramName?.rebateProgramCd]: true,
                }
              : {
                  [getRebateProgramName?.rebateProgramCd]: false,
                }
          )
        );
        if (!_.isEmpty(accountRecResponse)) {
          dispatch(ndcDetailFirstLoadAction(false));
          goToArSummaryAccRecNDCSingle(
            history,
            getRebateProgramName?.rebateProgramCd,
            dispatch
          );
        }
      } else {
        // dispatch(setErrorMessage([FAIL_PROCESSING_REQUEST]));
        setErrorMessage(FAIL_PROCESSING_REQUEST);
      }
    } catch (error) {
      setErrorMessage(FAIL_PROCESSING_REQUEST);
      // dispatch(setErrorMessage([FAIL_PROCESSING_REQUEST]));
    }
  };
  let paidAmtTot = 0;
  for (let i = 0; i < topBalances?.length; i += 1) {
    paidAmtTot += parseFloat(topBalances[i].top_balances_balance_due);
  }
  let calculate;
  let total = 0;
  if (!isNaN(paidAmtTot) || !isNaN(balance_due)) {
    total = parseFloat(paidAmtTot - balance_due);
    if (total < 0) {
      calculate = `($ ${parseFloat(-total).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
    } else {
      calculate = `$ ${parseFloat(total).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
  } else {
    calculate = '$ 0.00';
  }
  // pinned row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const [displayedRows, setDisplayedRows] = React.useState(topBalances ?? []);

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : topBalances;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };

  // const createData = (count, prefix) => {
  //   const result = [];
  //   for (let i = 0; i < count; i += 1) {
  //     result.push({
  //       isBottomRow: true,
  //       action: '',
  //       qtr: 'Total',
  //       invoice_NUM: '',
  //       principal_BAL: sum('principal_BAL'),
  //       interest_DUE: sum('interest_DUE'),
  //       top_balances_balance_due: sum('top_balances_balance_due'),
  //     });
  //   }
  //   return result;
  // };

  // const pinnedBottomRowData = useMemo(() => {
  //   return createData(2, 'Bottom');
  // }, [topBalances, filteredRows, filterApply]);

  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };

  const pinnedBottomRowData = useMemo(() => {
    return [
      {
        isBottomRow: true,
        action: '',
        qtr: 'Totals:', // This row will be shown in the table and export
        invoice_NUM: '',
        principal_BAL: sum('principal_BAL'),
        interest_DUE: sum('interest_DUE'),
        top_balances_balance_due: sum('top_balances_balance_due'),
      },
      {
        isBottomRow: true,
        action: '',
        qtr: 'Unallocated Balance:',
        invoice_NUM: '',
        principal_BAL: '',
        interest_DUE: '',
        top_balances_balance_due:
          convertCurrencyStringToNumber(balance_due1Text),
        hideInGrid: true,
        isBottomRowSup: true,
      },
      {
        isBottomRow: true,
        action: '',
        qtr: 'Total Balance Due:',
        invoice_NUM: '',
        principal_BAL: '',
        interest_DUE: '',
        top_balances_balance_due: convertCurrencyStringToNumber(calculate),
        hideInGrid: true,
        isBottomRowSup: true,
      },
    ];
  }, [topBalances, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  firstInfo = `Manufacturer ID : ${mfgValue}`;
  secondInfo = `Report Quarter Option: ${
    getQuarterRange == 'Selected Range'
      ? `${getQuarterFrom}-${getQuarterTo}`
      : getQuarterRange
  }`;
  thirdInfo = `${`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}`;
  fourthInfo = `Manufacturer Name : ${balData[count - 1]?.mfgName}`;
  const ActionCellRender = (cellInfo) => {
    if (cellInfo.data.isBottomRow) {
      return null;
    }
    return (
      <div className="tdCell icon-btn-group">
        <Dropdown className="icon-dropdown-container ml-2">
          <Dropdown.Toggle className="icon-dropdown" aria-label="Export">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
            >
              <SVGComponent iconName="Icon-export1" />
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="export_dropdown h-auto">
            <Dropdown.Item
              role="button"
              onClick={() => {
                handleGotoNDCDetails(cellInfo.data);
              }}
            >
              {' '}
              Go to Accounts Receivable NDC details
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <>
      <div className="tBillPanel custom-check tabs-container">
        <Spinner load={spinnerLoader} />
        <CustomSeparator
          parent1="Summary Reports"
          parent2="Display Top Balances"
        />
        {errorMessage && (
          <DisplayErrorMessages errorMessages={[errorMessage]} />
        )}
        {!fullScreenView && (
          <>
            {' '}
            <div className="row mb-5">
              <div className="col-12">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Manufacturer ID : "
                        id="Manufacturer ID : "
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="Manufacturer ID"
                        value={mfgValue}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12 mb-3">
                      <TextField
                        label="Number of Manufacturers Requested "
                        id="Number of Manufacturers Requested"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="Number of Manufacturers Requested"
                        disabled
                        value={getManufacturerListData}
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      {balData[count - 1]?.mfgName.length > 20 ? (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="com-tooltip">
                              {balData[count - 1]?.mfgName}
                            </Tooltip>
                          }
                        >
                          <TextField
                            label="Manufacturer Name "
                            id="Manufacturer Name"
                            fullWidth
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="Manufacturer Name "
                            disabled
                            value={`${balData[count - 1]?.mfgName.substring(
                              0,
                              20
                            )}... `}
                          />
                        </OverlayTrigger>
                      ) : (
                        <TextField
                          label="Manufacturer Name "
                          id="Manufacturer Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="Manufacturer Name "
                          disabled
                          value={balData[count - 1]?.mfgName}
                        />
                      )}
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Quarter_Option"
                        label="Quarter Option"
                        fullWidth
                        inputProps={{ id: 'Quarter_Option' }}
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          getQuarterRange == 'Selected Range'
                            ? `${dateRange[getQuarterRange]?.beginDate}-${dateRange[getQuarterRange]?.endDate}`
                            : getQuarterRange
                        }
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
        >
          <TableGrid
            getRowStyle
            ref={gridRef}
            gridCall={onGridReady}
            data-testid="onEditingStopped"
            rowSelection="single"
            countValue={count}
            noGlobalSort
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={topBalances}
            columnDefs={tableHead}
            exportFile
            animateRows
            sideBar={false}
            fileName="TopBalances"
            reportName={`Top ${getManufacturerListData} ${
              getCreditDebitIndexListData === '0' ? 'Credit' : 'Debit'
            } Balances Due Report`}
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            // isScrollOn
            suppressCellFocus
            hideColumnsInPdf={['actions']}
            onCellFocused={onCellFocused}
            onFilterData={onFilterChanged}
            pinnedBottomRowData={pinnedBottomRowData}
            exportAllTpPDF={getManufacturerListData > 1 ? exportAllTpPDF : null}
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
              sixthInfo: ' ',
            }}
            frameworkComponents={{
              ActionCellRender,
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 30) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            getFilterApply={getFilterApply}
            // frameworkComponents={detailsNDCframeworkComponents}
          />
        </div>
        <div className="panel custom-fieldset">
          <div className="custom-check">
            <div className="form-wrapper">
              <div className="mui-custom-form input-md">
                <div className="col-6">
                  <TextField
                    id="Unallocated_Balance"
                    label="Unallocated Balance"
                    fullWidth
                    className={
                      balance_due < 0 ? 'negative-balance' : 'positive-balance'
                      // unallocated < 0 ? 'negative-balance' : 'positive-balance'
                    }
                    placeholder=""
                    inputProps={{
                      id: 'Unallocated_Balance',
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // value={
                    //   unallocated < 0
                    //     ? `($ ${parseFloat(unallocated).toFixed(2)})`
                    //     : `$ ${parseFloat(unallocated).toFixed(2)}`
                    // }
                    value={balance_due1Text}
                    disabled
                  />
                </div>
              </div>
              <div className="mui-custom-form input-md">
                <div className="col-6">
                  <TextField
                    id="Total_Balance_Due"
                    label="Total Balance Due"
                    className={
                      // totalValue < 0 ? 'negative-balance' : 'positive-balance'
                      total < 0 ? 'negative-balance' : 'positive-balance'
                    }
                    fullWidth
                    placeholder=""
                    inputProps={{ id: 'Total_Balance_Due' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    // value={
                    //   totalValue < 0
                    //     ? `($ ${parseFloat(totalValue).toFixed(2)})`
                    //     : `$ ${parseFloat(totalValue).toFixed(2)}`
                    // }
                    value={calculate}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayTopBalances;
